<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <van-skeleton :row="18" :loading="loading">
      <div v-if="data" class="baseRect">
        <div class="title">概要</div>
        <van-row>
          <van-col span="12" class="line"><span :style="'color:'+GetColorMainBack()">项目</span>{{ data.rule.title }}</van-col>
          <van-col span="12" class="line"><span :style="'color:'+GetColorMainBack()">开始时间</span>{{ formatDate(data.rule.startTime,'yyyy/MM/dd hh:mm') }}</van-col>
        </van-row>
        <van-row>
          <van-col span="12" class="line"><span :style="'color:'+GetColorMainBack()">需要反馈</span>
            <van-tag v-if="data.rule.isNeedFeedback" type="success">需要</van-tag>
            <van-tag v-if="!data.rule.isNeedFeedback" type="danger">不需要</van-tag>
          </van-col>
          <van-col span="12" class="line"><span :style="'color:'+GetColorMainBack()">已反馈</span>
            <van-tag v-if="data.rule.isNeedFeedback && data.result" type="success">已反馈</van-tag>
            <van-tag v-if="data.rule.isNeedFeedback && !data.result" type="danger">未反馈</van-tag>
          </van-col>
        </van-row>
        <van-row v-if="data.startTimeBeginTime>0">
          <van-col span="24" class="line"><span :style="'color:'+GetColorMainBack()">即将开始</span>
            <van-count-down
              style="display: inline-block;"
              :time="data.startTimeBeginTime"
              :format="data.startTimeBeginTime>86400000?'DD天HH时mm分ss秒':'HH时mm分ss秒'"
            />
          </van-col>
        </van-row>
        <van-row>
          <van-col span="24" class="line"><span :style="'color:'+GetColorMainBack()">说明</span>{{ data.rule.remark }}</van-col>
        </van-row>
      </div>
      <div v-if="data" class="baseRect">
        <div class="title">宣传文案</div>
        <template v-if="data.startTimeBeginTime<=0">
          <div
            v-clipboard:copy="copyStr"
            v-clipboard:success="onCopyFinish"
            class="aboutData"
            @click="copyStr=undefined;copyStr= data.rule.about;"
          >{{ data.rule.about }}</div>
          <img v-for="(item,index) in dataImages" :key="index" :src="item" class="dataImage">
        </template>
        <div v-if="data.startTimeBeginTime>0" class="aboutData">即将开放</div>
      </div>

      <div v-if="data && fildDownload.length>0" class="baseRect">
        <div class="title">宣传文件下载</div>
        <template v-if="data.startTimeBeginTime<=0">
          <div v-for="(item,index) in fildDownload" :key="index" class="fileLine"><a :href="item"> 点击下载文件{{ index+1 }}</a></div>
        </template>
        <div v-if="data.startTimeBeginTime>0" class="aboutData">即将开放</div>
      </div>

      <div v-if="data && data.rule.isNeedFeedback && data.result" class="updateRect">
        <div class="inputRect">
          <div class="title">反馈情况</div>

          <van-row>
            <van-col span="12" class="line"><span :style="'color:'+GetColorMainBack()">状态</span>{{ GetEnumText('SignState', data.result.state) }}</van-col>
            <van-col span="12" class="line"><span :style="'color:'+GetColorMainBack()">反馈时间</span>{{ formatDate(data.result.createTime,'yyyy/MM/dd hh:mm',true) }}</van-col>
          </van-row>
          <van-col span="24" class="line"><span :style="'color:'+GetColorMainBack()">反馈说明</span>{{ data.result.remark }}</van-col>
          <van-col span="24" class="line"><span :style="'color:'+GetColorMainBack()">反馈截图</span></van-col>
          <img v-for="(item,index) in resultImages" :key="index" :src="item" class="dataImage">
          <van-row>
            <van-col span="12" class="line"><span :style="'color:'+GetColorMainBack()">审核人员</span>{{ data.manageUserName }}</van-col>
            <van-col span="12" class="line"><span :style="'color:'+GetColorMainBack()">审核时间</span>{{ data.result.verifyTime?formatDate(data.result.verifyTime,'yyyy/MM/dd hh:mm',true):'-' }}</van-col>
          </van-row>
          <van-col span="24" class="line"><span :style="'color:'+GetColorMainBack()">审核说明</span>{{ data.result.remarkAdmin }}</van-col>
        </div>
        <van-button type="primary" size="large" :color="GetColorMainBack()" :disabled="data.result.state==='SUCCESS'" :loading="buttonLoading" @click="onRemove">重新反馈</van-button>
      </div>
      <div v-if="data && data.rule.isNeedFeedback && !data.result" class="updateRect">

        <div class="inputRect">
          <van-col v-if="data.rule.shareRemark" span="24" class="line"><span :style="'color:'+GetColorMainBack()">反馈要求</span>{{ data.rule.shareRemark }}</van-col>
          <div class="imageTitle">反馈截图</div>
          <div class="imageUploadRect" :style="fileList.length>0?'text-align:left':'text-align:center'">
            <van-uploader
              v-model="fileList"
              class="imageUpload"
              multiple
              :max-count="5"
              :after-read="afterRead"
            />
          </div>
          <van-field
            v-model="remark"
            rows="3"
            autosize
            label="备注"
            type="textarea"
            placeholder="请输入备注"
          />
        </div>
        <van-button type="primary" size="large" :color="GetColorMainBack()" :disabled="data.startTimeBeginTime>0" :loading="buttonLoading" @click="onSubject">{{ data.startTimeBeginTime>0?'未到时间无法提交':'提交反馈' }}</van-button>
      </div>
    </van-skeleton>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Skeleton, CountDown, Tag, Field, Uploader, Dialog } from 'vant'
import TopBar from '@/components/TopBar'
import { compressorImageList, MyNotify, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Skeleton.name]: Skeleton,
    [CountDown.name]: CountDown,
    [Tag.name]: Tag,
    [Field.name]: Field,
    [Uploader.name]: Uploader,
    [Dialog.name]: Dialog,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '宣传资料',
      backurl: '/pro/index',
      ruleId: undefined,
      data: undefined,
      loading: true,
      buttonLoading: false,
      remark: '',
      fileList: [],
      dataImages: [],
      fildDownload: [],
      resultImages: [],
      copyStr: undefined
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.ruleId = this.$route.params.id
    this.init()
  },
  methods: {
    MyNotify,
    compressorImageList,
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    init() {
      this.loading = true
      request({
        url: '/Propaganda/GetProPropaganda',
        method: 'post',
        params: { id: this.ruleId }
      }).then(response => {
        this.loading = false
        if (!response.success) {
          return
        }
        this.data = response.data
        this.dataImages = []
        if (this.data.rule.images) {
          this.dataImages = this.data.rule.images.split(',')
        }
        this.fildDownload = []
        if (this.data.rule.files) {
          this.fildDownload = this.data.rule.files.split(',')
        }
        this.resultImages = []
        if (this.data.result && this.data.result.backImageUrls) {
          this.resultImages = this.data.result.backImageUrls.split(',')
        }
        this.titleTop = GetSysTitle()
      })
    },
    onCopyFinish(e) {
      MyNotify('success', '已复制:' + e.text, 2000)
    },
    onSubject() {
      this.buttonLoading = true
      this.uploadImg(this.fileList, (urls) => {
        var postData = {
          ruleId: this.ruleId,
          backImageUrls: urls,
          remark: this.remark
        }
        request({
          url: '/Propaganda/updateProPropaganda',
          method: 'post',
          data: postData
        }).then(response => {
          this.buttonLoading = false
          if (!response.success) {
            return
          }
          MyNotify('success', '提交成功')
          this.init()
        })
      })
    },
    onRemove() {
      Dialog.confirm({
        title: '重新反馈',
        message: '是否重新反馈?'
      })
        .then(() => {
          this.buttonLoading = true
          request({
            url: '/Propaganda/deleteProPropaganda',
            method: 'post',
            params: { id: this.ruleId }
          }).then(response => {
            this.buttonLoading = false
            if (!response.success) {
              return
            }
            MyNotify('success', '重置成功')
            this.init()
          })
        })
    },
    afterRead() {

    },
    uploadImg(files, callback) {
      var noFile = true
      var fileList = []
      files.map((value, index, array) => {
        if (value.file) {
          fileList.push(value.file)
          noFile = false
        }
      })
      if (noFile) {
        if (callback) {
          callback('')
        }
        return
      }
      compressorImageList(fileList, 1024, 1024, 0.6, (list) => {
        const formData = new FormData()
        list.map((value, index, array) => {
          if (value.name) {
            formData.append('file', value.file, value.name)
          } else {
            formData.append('file', value.file)
          }
        })
        request({
          url: '/Data/uploadFile?config=propagandaresult',
          method: 'post',
          data: formData
        }).then(response => {
          console.log('上传图片反馈', response)
          if (!response.success) {
            this.buttonLoading = false
            return
          }
          var list = []
          response.data.map((value, index, array) => {
            list.push(value.save)
          })
          if (callback) {
            callback(list.toString())
          }
        })
      })
    }
  }
}
</script>
<style scoped>
.title{
    font-size: 0.8em;
    line-height: 2.2em;
    font-weight: 700;
}
.baseRect{
    background-color: #fff;
    padding: 1em;
    margin:1em;
    border-radius: 0.4em;
}
.updateRect{
    background-color: #fff;
    margin:1em;
    border-radius: 0.4em;
    overflow: hidden;
}
.updateRect .inputRect{
    padding: 1em;
}
.line{
    font-size: 0.8em;
    line-height: 1.8em;
}
.line span{
    font-weight: 700;
    padding-right: 0.5em;
}
.dataImage{
    width:100%;
    padding: 0.5em 0;
}
.aboutData{
    font-size: 0.8em;
    margin: 1em 0;
}
.imageUploadRect{
  background-color: #fff;
}
.imageTitle{
    font-size: 0.8em;
    line-height: 1.8em;
}
.fileLine{
  font-size: 0.8em;
  line-height: 2.5em;
  text-align: center;
}
</style>
